import { FC } from "preact/compat";
import { useEffect, useRef } from "preact/hooks";
import { useSignal } from "@preact/signals";
import { AutoHeightProps } from "./interfaces";

const AutoHeight: FC<AutoHeightProps> = ({
    children,
    onTransitionEnd,
    className,
    expanded,
    manual,
    tag,
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const height = useSignal<string | number>("auto");
    const overflowHidden = useSignal(!expanded && !manual);

    useEffect(() => {
        const element = ref.current;

        if (!element || manual) {
            return;
        }

        height.value = element.clientHeight;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children, manual, tag]);

    useEffect(() => {
        const element = ref.current;

        if (!element || !manual) {
            return;
        }

        if (expanded) {
            height.value = "auto";

            const r = element.getBoundingClientRect();

            height.value = r.height;
        } else {
            overflowHidden.value = true;
            height.value = 0;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [manual, expanded, tag]);

    const handleTransitionEnd = (event: TransitionEvent) => {
        if (event.propertyName === "height") {
            onTransitionEnd?.();

            if (expanded) {
                overflowHidden.value = false;
            } else {
                overflowHidden.value = true;
            }
        }
    };

    return (
        <div
            style={{
                overflow: overflowHidden.value ? "hidden" : "initial",
                height: height.value,
                transition: "height 300ms",
            }}
            onTransitionEnd={handleTransitionEnd}
        >
            <div ref={ref} className={className}>
                {children}
            </div>
        </div>
    );
};

export default AutoHeight;
